import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-warning-confirm-modal',
  templateUrl: './warning-confirm-modal.component.html',
  styleUrls: ['./warning-confirm-modal.component.scss']
})
export class WarningConfirmModalComponent implements OnInit {
  @Input() title: any

  constructor(public bsModalRef: BsModalRef,
    private router: Router) { }

  ngOnInit() {
  }


  confirm() {
    this.bsModalRef.hide()
    this.router.navigateByUrl('/home/settings')
  }

  decline() {
    this.bsModalRef.hide()
  }

}
